const RECEIVE_OMNI_KEYWORD_LIST_DATA = 'src/omniKeywordList/RECEIVE_OMNI_KEYWORD_LIST_DATA' as const;
const START_FETCH = 'src/omniKeywordList/START_FETCH' as const;
const END_FETCH = 'src/omniKeywordList/EMD_FETCH' as const;

export default { RECEIVE_OMNI_KEYWORD_LIST_DATA, START_FETCH, END_FETCH };
